import { dataMarket } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMarket = /*#__PURE__*/createIcon(dataMarket)
export default IconMarket
